import { useQuery } from '@apollo/client';
import React from 'react';
import { RoleListContainerStaffRoleFieldsFragment, RoleListContainerStaffRolesQueryDocument, RoleListContainerStaffUserCurrentDocument } from '../../../../generated.tsx';
import { useOid } from '../../../../hooks/useOid.ts';
import { ComponentQueryLoader } from '../../../shared/component-query-loader.tsx';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheDisabled } from '../../../shared/utils/queryOptions';
import { RoleList } from './role-list.tsx';

interface EntitySearchContainerProps {
  filters: any;
}

export const RoleListContainer: React.FC<EntitySearchContainerProps> = () => {
  const oid = useOid();
  const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheDisabled(oid);

  const { data: dataRoleList, loading, error } = useQuery(RoleListContainerStaffRolesQueryDocument);
  const { data: staffUserCurrentData, loading: staffUserCurrentLoading, error: staffUserCurrentError } = useQuery(RoleListContainerStaffUserCurrentDocument, staffUserCurrentQueryOptions);

  return (
    <ComponentQueryLoader
      loading={loading || staffUserCurrentLoading}
      hasData={dataRoleList?.staffRoles && staffUserCurrentData?.staffUserCurrent}
      error={error || staffUserCurrentError}
      hasDataComponent={
        <RoleList
          data={dataRoleList?.staffRoles as RoleListContainerStaffRoleFieldsFragment[]}
          canAddRole={staffUserCurrentData?.staffUserCurrent?.role?.permissions?.rolePermissions?.canAddRoles ?? false}
        />
      }
    />
  );
};
